export function getCoords(elem: HTMLElement) {
  var box = elem.getBoundingClientRect();

  var body = document.body;
  var docEl = document.documentElement;

  var scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;
  var scrollLeft = window.pageXOffset || docEl.scrollLeft || body.scrollLeft;

  var clientTop = docEl.clientTop || body.clientTop || 0;
  var clientLeft = docEl.clientLeft || body.clientLeft || 0;

  var top = box.top + scrollTop - clientTop;
  var left = box.left + scrollLeft - clientLeft;

  return { top: Math.round(top), left: Math.round(left) };
}

export const flexDirFromDndPos = (
  position?: 'top' | 'bottom' | 'left' | 'right' | string,
) => {
  if (position === 'top') return 'column-reverse';
  if (position === 'bottom') return 'column';
  if (position === 'left') return 'row-reverse';
  return 'row';
};

export const dirFromDndPos = (
  position?: 'top' | 'bottom' | 'left' | 'right' | string,
) => {
  if (position === 'top' || position === 'bottom') return 'row';
  return 'column';
};
